export default "/_next/static/images/e87f9b537845c374afdbee88779f945f.jpg";